import {
    SET_CUSTOMER,
} from '../../constants/ActionTypes';
import customerInitialState from './customerInitialState';

function customerReducer(state = customerInitialState, action) {
    switch (action.type) {
    case SET_CUSTOMER: {
        if (action.data) {
            return {
                ...state,
                uid: action.data.uid,
                mail: action.data.mail,
            };
        }
        return {
            ...state,
        };
    }
    default:
        return state;
    }
}

export default customerReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/customerReducer.js